import React from "react";
import classNames from "classnames";
import ContentEditorComponent from "@components/ContentEditorView/ContentEditorComponent";

const Section = (props) => {
  const sectionClass = classNames({
    "u-border-b-dotted": props.borderBottom,
    "u-border-t-dotted": props.borderTop,
    "u-space-mb-10 u-space-mt-10": props.verticalMargin,
    "u-space-pt-10 u-space-pb-10": props.verticalPadding,
    "u-space-p-10": props.fullPadding,
    "Content-children-inherit": props.color,
  });

  const sectionStyles = {
    backgroundColor:
      props.bgColor && props.bgColor.length > 0 ? props.bgColor : null,
    color: props.color && props.color.length > 0 ? props.color : null,
  };

  return (
    <div className={sectionClass} style={sectionStyles}>
      {props.children && <ContentEditorComponent content={props.children} />}
    </div>
  );
};

export default Section;
